import styled from 'styled-components';
/* Warning: do not import components from material ui into video.js components */
export const Switch = styled.label `
    position: relative;
    display: inline-block;
    width: 30px;
    height: 17px;

    input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: 0.2s;
        transition: 0.2s;
    }

    .slider:before {
        position: absolute;
        content: '';
        height: 13px;
        width: 13px;
        left: 2px;
        bottom: 2px;
        background-color: white;
        -webkit-transition: 0.2s;
        transition: 0.2s;
    }

    input:checked + .slider {
        background-color: #0277bd;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #0277bd;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(13px);
        -ms-transform: translateX(13px);
        transform: translateX(13px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 17px;
    }

    .slider.round:before {
        border-radius: 50%;
    }
`;
//# sourceMappingURL=index.styles.js.map